import React from "react";
import useFinancialData from "./useFinancialData";
import gettext from "../../shared/utils/gettext";
import DashBoardFinancialTileContent from "./DashBoardFinancialTileContent";

export default function DashboardFinancialCropfieldTile({ cropFieldId = undefined }) {
  const data = useFinancialData({ cropFieldId });
  return (
    <div className="d-flex justify-content-left">
      <div className="text-center mx-5">
        <div className="text-muted mb-3">{gettext("Financial")}</div>
        <DashBoardFinancialTileContent {...data} className="table-borderless w-auto mx-5" />
      </div>
    </div>
  );
}
